import * as React from 'react'

export default () => (
  <svg width='384' height='267' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <g clipPath='url(#b)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M362.099 183.247a1 1 0 0 1-1.39.26l-36.59-25.073a1 1 0 1 1 1.13-1.65l36.59 25.073a1 1 0 0 1 .26 1.39Zm-48.759 63.56a.999.999 0 0 1-1.414-.011c-1.154-1.173-2.513-3.475-3.933-6.289-1.44-2.855-3.004-6.364-4.548-10.057-3.088-7.388-6.121-15.566-7.971-20.843a1.002 1.002 0 0 1 1.888-.662c1.841 5.252 4.859 13.391 7.929 20.734 1.535 3.672 3.077 7.132 4.488 9.927 1.431 2.837 2.667 4.867 3.573 5.787a1 1 0 0 1-.012 1.414Zm-53.342-37.002a1 1 0 0 0-1.91-.593l-9.708 31.259a1 1 0 1 0 1.91.593l9.708-31.259ZM370.307 50.913a1 1 0 0 1-.988 1.012c-.094.001-.361.052-.851.24-.461.178-1.03.44-1.691.779-1.318.675-2.934 1.616-4.646 2.672-3.42 2.11-7.164 4.641-9.566 6.328a1 1 0 1 1-1.149-1.637c2.423-1.702 6.201-4.257 9.665-6.393 1.731-1.068 3.397-2.04 4.785-2.75a20.122 20.122 0 0 1 1.884-.865c.522-.201 1.072-.368 1.545-.374a1 1 0 0 1 1.012.988Zm9.657 58.489a1 1 0 0 0-.251-1.984l-32.801 4.145a1 1 0 1 0 .251 1.984l32.801-4.145Z'
          fill='currentColor'
        />
      </g>
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h384v267H0z' />
      </clipPath>
      <clipPath id='b'>
        <path
          fill='currentColor'
          transform='rotate(-162.747 186.569 118.249)'
          d='M0 0h94.943v241.206H0z'
        />
      </clipPath>
    </defs>
  </svg>
)
